import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useCancelSpecialMedicalSubmit */
export type TypeCancelSpecialMedicalSubmitResponse = {
  /** 응답 메시지 */
  message: string;
};

/**
 * @description 작업자의 특수건강검진 검진확인증 제출 취소 (승인대기 → 등록)
 */
export const useSubmitCancelSpecialMedical = ({ isSecond = false }: { isSecond?: boolean } = {}) => {
  const { mutateAsync } = useMutation({
    mutationFn: () => {
      const endpoint = '/labor-accounts/examinations/special-medicals/cancel';
      const secondEndpoint = '/labor-accounts/examinations/special-medicals/second/cancel';

      return axiosInstance.patch(isSecond ? secondEndpoint : endpoint);
    },
  });

  const requestSubmitCancelSpecialMedical = async ({
    onSuccess,
    onError,
    onFinally,
  }: {
    onSuccess?: (response: TypeCancelSpecialMedicalSubmitResponse) => void;
    onError?: (error: TypeErrorFormat) => void;
    onFinally?: () => void;
  }) => {
    requestHelper(() => mutateAsync(), onSuccess, onError, onFinally);
  };

  return requestSubmitCancelSpecialMedical;
};
